import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

type Props = {
    text?: string;
};

export const ChatMessageError = ({ text }: Props) => {
    return (
        <Text
            fontVariant="sectionTitle"
            color={colorsPalettes.red[500]}
            margin="12px 0"
        >
            {text ?? translate("si.agent.error.message.render")}
        </Text>
    );
};
